'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _coreDecorators = require('core-decorators');

var _styling = require('@rexlabs/styling');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _renderLoading = require('./render-loading');

var _renderLoading2 = _interopRequireDefault(_renderLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyles = (0, _styling.StyleSheet)({
  listContainer: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    transform: 'translate3d(0, 0, 0)'
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: '60vh'
  }
});

var RenderLoadingList = (_dec = (0, _styling.styled)(defaultStyles), _dec(_class = (0, _coreDecorators.autobind)(_class = (_temp = _class2 = function (_React$PureComponent) {
  (0, _inherits3.default)(RenderLoadingList, _React$PureComponent);

  function RenderLoadingList() {
    (0, _classCallCheck3.default)(this, RenderLoadingList);
    return (0, _possibleConstructorReturn3.default)(this, (RenderLoadingList.__proto__ || (0, _getPrototypeOf2.default)(RenderLoadingList)).apply(this, arguments));
  }

  (0, _createClass3.default)(RenderLoadingList, [{
    key: 'getListLoadingOrError',
    value: function getListLoadingOrError() {
      var _props = this.props,
          isListLoading = _props.isListLoading,
          fetchErrors = _props.fetchErrors,
          ListLoadingView = _props.ListLoadingView,
          ListErrorView = _props.ListErrorView,
          s = _props.styles;


      var listErrorElement = _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, s('listContainer'), { key: 'listError' }),
        _react2.default.createElement(
          'div',
          s('inner'),
          _react2.default.createElement(ListErrorView, { errors: fetchErrors })
        )
      );

      var listLoadingElement = _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, s('listContainer'), { key: 'listLoading' }),
        _react2.default.createElement(
          'div',
          s('inner'),
          _react2.default.createElement(ListLoadingView, null)
        )
      );

      if (fetchErrors && fetchErrors.length) {
        return listErrorElement;
      }

      if (isListLoading) {
        return listLoadingElement;
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isListLoading = _props2.isListLoading,
          fetchErrors = _props2.fetchErrors,
          ListLoadingView = _props2.ListLoadingView,
          ListErrorView = _props2.ListErrorView,
          s = _props2.styles,
          rest = (0, _objectWithoutProperties3.default)(_props2, ['isListLoading', 'fetchErrors', 'ListLoadingView', 'ListErrorView', 'styles']);

      return _react2.default.createElement(_renderLoading2.default, (0, _extends3.default)({}, rest, { ContentAfter: this.getListLoadingOrError() }));
    }
  }]);
  return RenderLoadingList;
}(_react2.default.PureComponent), _class2.displayName = 'RenderLoadingList', _class2.defaultProps = {
  ListLoadingView: function ListLoadingView() {
    return _react2.default.createElement(
      'div',
      null,
      'List loading'
    );
  },
  ListErrorView: function ListErrorView(_ref) {
    var errors = _ref.errors;
    return _react2.default.createElement(
      'div',
      null,
      errors.map(function (message, i) {
        return _react2.default.createElement(
          'span',
          { key: i },
          message
        );
      })
    );
  }
}, _temp)) || _class) || _class);
process.env.NODE_ENV !== "production" ? RenderLoadingList.propTypes = {
  isListLoading: _propTypes2.default.bool,
  fetchErrors: _propTypes2.default.array,
  ListLoadingView: _propTypes2.default.func,
  ListErrorView: _propTypes2.default.func
} : void 0;
exports.default = RenderLoadingList;